import React from "react";
import styles from '../LinkPersonalizado8/linkPersonalizado8.module.scss';

interface LinkPersonalizado8Props {
    href: string;
    title: string;
    colorText: string;
    backgroundColor: string;
    backgroundColorHover: string;
}

const LinkPersonalizado8: React.FC<LinkPersonalizado8Props> = ({
    href,
    title,
    colorText,
    backgroundColor,
    backgroundColorHover,
}) => {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            style={{
                color: colorText,
                backgroundColor: backgroundColor,
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = backgroundColorHover}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = backgroundColor}
        >
            {title}
        </a>
    );
};

export default LinkPersonalizado8;
